export class FormMessage {
  type;
  message?: any;

  constructor(type, message?: any) {
    this.type = type;
    if (message) this.message = message;
  }
}
